<template>
  <div class="order notice-order">
    <search :search-obj-list="search"
            search-obj-type
            new-str="新建发货通知单"
            @toNew="showNewDrawer"
            @reSearch="reSearch"
            check-url="user.sales.1.notice.add">
      <template #search="{item,pushTab}">
        <div style="display: inline-block">
          <div v-if="item.name==='客户名称'">
            <customer-auto-complete :value.sync="item.value"
                                    placeholder="请输入客户名称"
                                    @setTags="pushTab"/>
          </div>
          <div v-if="item.name==='仓库'">
            <warehouse-auto-complete :value.sync="item.value"
                                     @setTags="pushTab"/>
          </div>
          <div v-if="item.name==='创建人'">
            <cust-user-name-auto-complete :value.sync="item.value"
                                          placeholder="请输入创建人"
                                          tag-param="operatorId"
                                          tag-name="创建人"
                                          @setTags="pushTab"/>
          </div>
        </div>
      </template>
    </search>
    <div class="order-table">
      <div class="order-main-header" style="position: relative">
        <el-tabs v-model="status" @tab-click="tableFlagAdd">
          <el-tab-pane :key="item.NAME"
                       :name="String(item.CODE)"
                       v-for="item in tabValueList">
            <span slot="label">{{ item.NAME }}</span>
          </el-tab-pane>
        </el-tabs>
        <el-popover
            style="position: absolute; right: 0px"
            placement="bottom-end"
            title="列筛选"
            trigger="click"
            v-model="popoverIsShow">
            <el-checkbox v-for="item in tableFields"
                         :key="item.prop"
                         v-model="item.fieldIsShow"
                         class="checkBoxesBlock">{{item.label}}</el-checkbox>
            <el-button type="primary"
                               size="medium"
                               style="width: 80px"
                               @click="splitFields">完成</el-button>
            <i class="el-icon-s-operation" slot="reference"/>
        </el-popover>
      </div>
      <qx-table :qx-table="qxTable" :indices="false"
                @updateTable="updateTable">
        <template slot="table" slot-scope="data">
          <el-table :data="data.table"
                    fit
                    show-overflow-tooltip
                    border
                    :row-style="{ height: '71px' }"
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    row-key="ids"
                    :row-class-name="tableRowClassName"
                    class="noticeTable">
            <el-table-column label="" width="50"></el-table-column>
            <!-- <el-table-column label="序号" width="60">
              <template slot-scope="scope">
                {{
                  data.page.pageNum > 0 ? ((data.page.pageNum - 1)
                    * data.page.pageSize) + (scope.$index += 1) : scope.$index += 1
                }}
              </template>
            </el-table-column> -->
            <el-table-column v-for="item in tableSplitFields"
                             :label="item.label" :prop="item.prop" :key="item.prop"
                             :width="item.width" :fixed="item.fixed">
              <template slot-scope="scope">
                <template v-if="item.prop==='status'">
                  <span>{{ showStatus(scope.row.pickStatus, scope.row.status) }}</span>
                </template>
                <template v-else-if="item.prop==='urgent'">
                  <span>{{ scope.row.urgent ? '是' : '否' }}</span>
                </template>
                <template v-else-if="item.prop==='warehouse'">
                  <span>{{ scope.row.orderList.map(e => e.warehouse).filter((i,index) => scope.row.orderList.map(e => e.warehouse).indexOf(i) === index).join(',') }}</span>
                </template>
                <template v-else-if="item.prop==='goodsType'">
                  <span>{{ scope.row.baseInfoV.goodsType }}</span>
                </template>
                <template v-else-if="item.prop==='operatorName'">
                  <span>{{ scope.row.baseInfoV.custLeadName ? scope.row.baseInfoV.custLeadName : scope.row.operatorName }}</span>
                </template>
                <template v-else-if="item.prop==='artName'">
                  <span>{{ scope.row.baseInfoV.artName }}</span>
                </template>
                <template v-else-if="item.prop==='custName'">
                    <span>{{ scope.row.baseInfoV.custName }}</span>
                </template>
                <template v-else-if="item.prop==='deliveryTime'">
                  <span>{{ scope.row.baseInfoV.deliveryTime }}</span>
                </template>
                <template v-else-if="item.prop==='orderOperatorName'">
                  <span>{{ scope.row.baseInfoV.orderOperatorName }}</span>
                </template>
                <template v-else-if="item.prop==='goodsNoList'">
                  <span>{{ utils.getListIdStr(scope.row.orderList, 'goodsNo') }}</span>
                </template>
                <template v-else-if="item.prop==='noticeMainCount'">
                  <span>{{ math.sum(scope.row.orderList.map(e => e.noticeMainCount || 0)) + utils.getListIdStr(scope.row.orderList, 'noticeMainUnit') }}</span>
                </template>
                <!-- <template v-else-if="item.prop==='noticeMainUnit'">
                  <span>{{ utils.getListIdStr(scope.row.orderList, 'noticeMainUnit') }}</span>
                </template> -->
                <!-- <template v-else-if="item.prop==='noticeSlaveQuantity'">
                  <span>{{ math.sum(scope.row.orderList.map(e => e.noticeSlaveQuantity || 0)) }}</span>
                </template> -->
                <!-- <template v-else-if="item.prop==='noticeSlaveUnit'">
                  <span>{{ utils.getListIdStr(scope.row.orderList, 'noticeSlaveUnit') }}</span>
                </template> -->
                <template v-else-if="item.prop==='saleOrderNo'">
                  <span>{{ utils.getListIdStr(scope.row.orderList, 'saleOrderNo') }}</span>
                </template>
                <template v-else-if="item.prop==='totalWeight'">
                  <span>{{ scope.row.baseInfoV.totalWeight ? scope.row.baseInfoV.totalWeight.toFixed(1) : '' }}</span>
                </template>
                <template v-else-if="item.prop==='shippingMethod'">
                  <span>{{ getShippingMethod(scope.row) }}</span>
                </template>
                <template v-else-if="item.prop==='address'">
                    <span>
                      {{ scope.row.baseInfoV.contactName && scope.row.baseInfoV.contactPhone ? scope.row.baseInfoV.contactName + '/' + scope.row.baseInfoV.contactPhone + '/' + scope.row.baseInfoV.address.province + scope.row.baseInfoV.address.city + scope.row.baseInfoV.address.county + scope.row.baseInfoV.address.other : '' }}
                    </span>
                </template>
                <template v-else-if="item.prop==='custUserName'">
                  <span>{{ scope.row.baseInfoV.custUserName }}</span>
                </template>
                <template v-else>
                  <span>
                    {{ scope.row[item.prop] }}
                  </span>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="280px">
              <template slot-scope="scope">
                <div class="table-operator">
                  <i class="el-icon-third-chakan" v-show="scope.row.status" @click="details(scope.row,scope.$index)"/>
                  <i class="el-icon-third-bianji" v-show="[1, 5].includes(scope.row.status)"
                     @click="modify(scope.row,scope.$index)"/>
                  <i class="el-icon-download" title="下载" v-show="[1, 3, 4].includes(scope.row.status)"
                     @click="exportList(scope.row,scope.$index)"/>
                  <i class="el-icon-third-shenqing2" title="复制" v-show="scope.row.status"
                     @click="copy(scope.row,scope.$index)"/>
                  <i class="el-icon-third-lajitong" v-show="[1, 5].includes(scope.row.status)"
                     @click="remove(scope.row,scope.$index)"/>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </qx-table>
    </div>
    <el-dialog title="下载" :visible.sync="dialogExport" width="25%" center>
        <el-form :model="form" style="padding-top: 20px">
            <el-form-item label="下载数据：" label-width="120px">
                <el-select v-model="form.list" placeholder="请选择单据" @change="listChange">
                    <el-option
                        v-for="item in listOptionsFilter"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="数据模板："
                        label-width="120px"
                        v-if="['销售单', '销售单(带码单)', 'INV', 'INV(DPL+PL)'].includes(form.list)">
                <el-select v-model="form.model" placeholder="请选择模板名称">
                    <el-option
                        v-for="item in modelOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogExport = false">取 消</el-button>
            <el-button type="primary" @click="listExport">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import QxTable from '../../mixins/order/common/QxTable';
import Order from '../../mixins/order/common/Order';
import NoticeOrder from '../../bean/order/NoticeOrder';
import moment from 'moment';

/**
 * @Description:
 * @Author: 菩萨蛮
 * @Date: 2020/9/24 9:51 上午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */

export default {
  name: 'NoticeOrder',
  mixins: [QxTable, Order],
  qx: {
    pageType: 'table',
    order: {
      ...NoticeOrder,
      warehouse: { title: '仓库', style: { overflow: true }, fieldIsShow: true },
      goodsNoList: { title: '物品编号', style: { overflow: true }, fieldIsShow: true },
      goodsNo: { title: '物品编号', search: true, visible: false, fieldIsShow: true },
      noticeMainCount: { title: '主数量', type: 'slot', fieldIsShow: true },
      // noticeMainCount: { title: '本次通知主数量', type: 'slot', fieldIsShow: true },
      // noticeMainUnit: { title: '主单位', type: 'slot', fieldIsShow: true },
      // noticeSlaveQuantity: { title: '本次通知件数', type: 'slot', fieldIsShow: true },
      saleOrderNo: { title: '销售订单编号', search: true, style: { overflow: true }, fieldIsShow: true },
      operatorName: { title: '创建人', fieldIsShow: true },
      operatorId: { title: '创建人', search: true, isShow: false, visible: false, searchType: 'slot' },
      userName: { title: '类型', required: true, type: 'select', search: false, fieldIsShow: true, visible: false },
      totalWeight: { title: '重量', fieldIsShow: true, style: { width: '120px'} },
      shippingMethod: { title: '发货方式', type: 'select', fieldIsShow: true, search: true, selectList: [
        { label: '物流', value: '物流' },
        { label: '快递', value: '快递' },
        { label: '自提', value: '自提' }
      ] },
      // custUserName: { title: '客户负责人', search: true, fieldIsShow: true },
    }
  },
  data() {
    return {
      pushUrl: '/notice-order-dahuo',
      tabValueList: Object.values(this.CONSTANT.STATE_NOTICE_ORDER),
      qxTable: { url: '/sales/notice_order', table: [] },
      orderUrl: 'notice-order',
      popoverIsShow: false,
      tableFields: [],
      tableSplitFields: [],
      // warhouseOptions:[],
      // form: {
      //     warehouse: '',
      //     row: {}
      // },
      form: {
          list: '',
          model: '',
          warehouse: '',
          row: {}
      },
      dialogExport: false,
      listOptions: [
          { label: '销售单', value: '销售单', showStatus: ['1', '3', '4'] },
          { label: '销售单(带码单)', value: '销售单(带码单)', showStatus: ['3', '4'] },
          { label: 'INV', value: 'INV', showStatus: ['1', '3', '4'] },
          { label: 'INV(DPL+PL)', value: 'INV(DPL+PL)', showStatus: ['3', '4'] },
          { label: '检验报告', value: '检验报告', showStatus: ['3', '4'] },
          { label: '附件', value: '附件', showStatus: ['1', '3', '4'] }
      ],
      modelOptions: [],
      warehouseOptions: [],
      shippingForm: {
          shippingMethod: '',
          logistics: '',
          invoiceNo: '',
          file: []
      },
      dialogNotice: false,
      shippingMethodDrawer: false,
      currentNoticeOrder: {},
      hasChildren: true,
      status: '1',
      currentIndex: -1
    };
  },
  mounted() {
    this.tableFields = JSON.parse(JSON.stringify(this.tableItems));
    if (localStorage.getItem('isShowNotice') !== null) {
      this.tableFields = JSON.parse(localStorage.getItem('isShowNotice'));
    }
    this.tableSplitFields = this.tableFields.filter(item => item.fieldIsShow === true);
  },
  computed: {
    tableSplitField() {
      return JSON.parse(JSON.stringify(this.tableFields.filter(item => item.fieldIsShow === true)));
    },
    listOptionsFilter() {
      let arr = this.listOptions.filter(item => item.showStatus.includes(this.status));
      return arr;
    },
  },
  methods: {
    showTips(obj, row, column, scope){
      /*obj为鼠标移入时的事件对象*/
      /*width为文本在页面中所占的宽度，创建标签，加入到页面，获取width,最后在移除*/
      let TemporaryTag = document.createElement('span');
      TemporaryTag.style.fontSize = '14px'
      TemporaryTag.innerText = obj.target.innerText;
      TemporaryTag.className = 'getTextWidth';
      document.querySelector('body').appendChild(TemporaryTag);
      let currentWidth = document.querySelector('.getTextWidth').offsetWidth;
      document.querySelector('.getTextWidth').remove();
      /*cellWidth为表格容器的宽度*/
      const cellWidth = obj.target.offsetWidth
      /*当文本宽度小于||等于容器宽度两倍时，代表文本显示未超过两行*/
      currentWidth <= (2*cellWidth) ? row.showTooltip = false : row.showTooltip = true;
    },
    showStatus(pickStatus, status) {
      if (status === 4) {
        return '已完成'
      } else if (status === 5) {
        return '草稿'
      } else if (status === 1) {
        return '待发货'
      } else if (status === 3) {
        return '发货中'
      } else {
        return ''
      }
    },
    getShippingMethod(row) {
        let arr = [];
        row.logisticses.forEach(item => {
            arr.push(this.showShippingMethod(item));
        });
        return arr.filter(item => item).join(',');
    },
    showShippingMethod(item) {
        if (!item || !item.shippingMethod) {
            return '';
        }
        if (['物流', '自提', '集装箱'].includes(item.shippingMethod)) {
            if (item.logistics) {
                return `${item.shippingMethod}(${item.logistics})`;
            } else {
                return `${item.shippingMethod}`;
            }
        } else if (['快递'].includes(item.shippingMethod)) {
            if (item.expressNumber) {
                let expressNumberList = item.expressNumber.split(',');
                let arr = [];
                expressNumberList.forEach((item, index) => {
                    arr.push(`${item}`);
                })
                return `${item.shippingMethod}(${arr.join(',')})`
            } else {
                return `${item.shippingMethod}`;
            }
        } else {
            return '';
        }
    },
    async exportList(row, index) {
        this.currentIndex = index;
        this.dialogExport = true;
        this.form.list = '';
        this.form.model = '';
        this.form.warehouse = '';
        this.modelOptions = [];
        this.warehouseOptions = [];
        this.form.row = row;
    },
    async listChange() {
        this.form.model = '';
        this.form.warehouse = '';
        this.modelOptions = [];
        this.warehouseOptions = [];
        if (['销售单', '销售单(带码单)'].includes(this.form.list)) {
            const { data } = await this.qGet('global/print/template?orderType=notice_sale_code_ch');
            if (data.datas) {
                data.datas.forEach(item => {
                    this.modelOptions.push({
                        value: item.id,
                        label: item.templateName
                    });
                });
            }
        }
        if (['INV', 'INV(DPL+PL)'].includes(this.form.list)) {
            const { data } = await this.qGet('global/print/template?orderType=notice_sale_code_en');
            if (data.datas) {
                data.datas.forEach(item => {
                    this.modelOptions.push({
                        value: item.id,
                        label: item.templateName
                    });
                });
            }
        }
    },
    async listExport() {
        if (this.form.list === '') {
            this.$message({
                message: '请选择下载数据',
                type: 'warning'
            });
            return;
        }
        if (['销售单', '销售单(带码单)', 'INV', 'INV(DPL+PL)'].includes(this.form.list)) {
            if (this.form.model === '') {
                this.$message({
                    message: '请选择模板',
                    type: 'warning'
                });
                return;
            }
            const Authorization = localStorage.getItem('token');
            let language = '';
            let type = '';
            if (['销售单', '销售单(带码单)'].includes(this.form.list)) {
                language = '1';
            } else {
                language = '2';
            }
            if (['销售单', 'INV'].includes(this.form.list)) {
                type = '2';
            } else {
                type = '3';
            }
            const res = await this.qxAxios({
                url: `/sales/notice_order/export/${this.form.row.id}/${this.form.model}/${language}/${type}`,
                method: 'get',
                responseType: 'blob',
                headers: { Authorization }
            });
            if (res.status === 200) {
                const today = moment().format('yyyyMMDD');
                const a = document.createElement('a');
                a.download = `${this.form.row.baseInfoV.custName}-${this.form.list}-${today}.xlsx`;
                a.href = URL.createObjectURL(res.data);
                a.click();
            }
        }
        if (this.form.list === '检验报告') {
          const Authorization = localStorage.getItem('token');
          const res = await this.qxAxios({
              url: `/warehouse/boundInstructions/exportRecordByNoticeId/${this.form.row.id}`,
              method: 'get',
              responseType: 'blob',
              headers: { Authorization }
          });
          if (res.status === 200) {
              const today = moment().format('yyyyMMDD');
              const a = document.createElement('a');
              a.download = `${this.form.row.baseInfoV.custName}-检验报告-${today}.xlsx`;
              a.href = URL.createObjectURL(res.data);
              a.click();
          }
        }
        if (this.form.list === '附件') {
            const { file } = this.form.row.logistics;
            const { saleFile } = this.form.row.logistics;
            if (!file && !saleFile) {
                this.$message.error('请先上传附件！');
                return;
            }
            const uuids = file.map(f => f.uuid).concat(saleFile.map(s => s.uuid));
            if (uuids && uuids.length) {
                const Authorization = localStorage.getItem('token');
                const res = await this.qxAxios({
                    url: '/dfs/file/zip',
                    method: 'post',
                    responseType: 'blob',
                    headers: { Authorization },
                    data: {
                        uuids,
                        companyId: JSON.parse(localStorage.getItem('user')).companyId,
                        systemType: 6
                    }
                });
                if (res.status === 200) {
                    const a = document.createElement('a');
                    if (file.length + saleFile.length === 1) {
                      if (file.length === 1) {
                        a.download = file[0].fileName;
                      } else {
                        a.download = saleFile[0].fileName;
                      }
                    } else {
                      a.download = '附件.zip';
                    }
                    a.href = URL.createObjectURL(res.data);
                    a.click();
                }
            } else {
                this.$message.error('当前指令没有附件！');
            }
        }
        this.dialogExport = false;
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex === this.currentIndex) {
        return 'row-active';
      }
      return '';
    },
    updateTable(data) {
      data.table.forEach(item => {
        let warehouses = [];
        item.ids = item.id;
        item.children = [];
        item.orderList.forEach((i,index) => {
          if (warehouses.indexOf(i.warehouse) === -1) {
            warehouses.push(i.warehouse);
            item.children.push({
              ids: `${item.id}${index}`,
              orderList: [i],
              logistics: {},
              logisticses: [],
              baseInfoV: {
                totalWeight: i.goodsWeight,
                address:{
                  province:'',
                  city:'',
                  other:'',
                  county:''
                }
              }
            })
          } else {
            item.children[warehouses.indexOf(i.warehouse)].orderList.push(i)
            item.children[warehouses.indexOf(i.warehouse)].baseInfoV.totalWeight += i.goodsWeight
          }
        })
        if (warehouses.length === 1) {
          delete item.children;
        }
      })
      this.qxTable.table = data.table;
    },
    reSearch(tags) {
      this.qxTable.searchObj = this.defaultSearchObj();
      tags.map(tag => {
        this.qxTable.searchObj[tag.param] = tag.value;
        return true;
      });
      this.tableFlagAdd();
    },
    sum(arr) {
      let sum = 0;
      arr.forEach(e => {
        sum += e;
      });
      return sum;
    },
    defaultSearchObj() {
      let s;
      if (this.qxTable && this.qxTable.searchObj) {
        s = this.qxTable.searchObj.status;
      }
      return {
        userName: '大货',
        status: s || '1,2,3'
      };
    },
    splitFields() {
      this.tableSplitFields = this.tableSplitField;
      localStorage.setItem('isShowNotice', JSON.stringify(this.tableFields));
      this.popoverIsShow = false;
    },
    showNewDrawer() {
      this.$router.push(`/new-${this.orderUrl}-dahuo`);
    },
    modify(row, index) {
      this.currentIndex = index;
      this.$router.push(`/modify-${this.orderUrl}-dahuo/${row.id}`);
    },
    details(row, index) {
      this.currentIndex = index;
      window.open(`/scmweb/check-${this.orderUrl}/${row.id}`);
    },
    async remove(row, index) {
      this.currentIndex = index;
      if (row.status === 2) {
        this.$message.error('该发货通知单已处于已安排状态，无法删除，请联系相关业务员！');
      } else if (row.pickStatus === 2) {
        this.$message.error('该发货通知单已处于待发货状态，无法删除，请联系相关业务员！');
      } else {
        await this.deleteOrderFunc(row);
      }
    },
    copy(row, index) {
      this.currentIndex = index;
      localStorage.setItem('noticeId', row.id);
      this.$router.push(`/new-${this.orderUrl}-dahuo`);
    },
    async noticeExport() {
      this.dialogNotice = false;
      const Authorization = localStorage.getItem('token');
      const res = await this.qxAxios({
          url: `/sales/notice_order/export?id=${this.form.row.id}&warehouse=${this.form.warehouse}`,
          method: 'get',
          responseType: 'blob',
          headers: { Authorization }
      });
      if (res.status === 200) {
          const a = document.createElement('a');
          a.download = '发货通知单.xlsx';
          a.href = URL.createObjectURL(res.data);
          a.click();
      }
    }
  },
  watch: {
    status: {
      handler() {
        if (this.status === '12') {
          this.qxTable.searchObj.status = '1,2,3';
        } else {
          this.qxTable.searchObj.status = this.status;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  ::v-deep ::-webkit-scrollbar {
        width: 10px !important;
        height: 10px !important;
    }
    ::v-deep ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        border-style: dashed;
        border-color: transparent;
        border-width: 3px;
        background-color: #a8a8a8;
        background-clip: padding-box;
    }
    ::v-deep ::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }
    ::v-deep .el-table__fixed-right-patch {
        width: 15px !important;
        background-color: #e9edf0;
    }
    ::v-deep .el-table__fixed-body-wrapper {
        max-height: calc(100vh - 380px);
        overflow-y: hidden;
    }
    ::v-deep .el-table__fixed-right {
        right: 10px;
    }
  .noticeTable{
    span {
      display:-webkit-box;
      text-overflow:ellipsis;
      overflow:hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient:vertical;
    }
  }
  .overhide {
      display: -webkit-box ;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
  }
  .file-list {
    width: 200px;
    height: 600px;
  }
  ::v-deep .el-drawer__header {
    font-size: 16px ;
  }
  .el-icon-truck {
    font-size: 16px;
  }
  .el-icon-refresh-left {
    font-size: 16px;
  }
  .el-icon-download {
    font-size: 16px;
  }
  .shipping-method-drawer {
    .shipping-method-drawer-content {
      margin: 0 20px;
    }
    .shipping-method-drawer-footer {
      position: absolute;
      display: flex;
      bottom: 20px;
      width: calc(100% - 40px);
      box-sizing: border-box;
      .el-button {
        width: 50%;
        height: 40px;
        font-weight: 400;
        font-size: 16px;
      }
    }
  }
  .checkBoxesBlock {
      display: block;
      margin: 5px 0;
  }
  .el-icon-s-operation {
      font-size: 30px;
      margin: 10px;
      float: right;
  }
  .dialog-footer {
        margin-top: 20px;
        text-align: center;

        .el-button {
            width: 100px;
            height: 30px;
            border-radius: 6px;
            font-weight: 500;
            font-size: 12px;

            &.el-button--default {
                border: 1px solid #ced0da;
                color: #6a7079;
                background-color: #fff;
            }

            &.el-button--primary {
                margin-left: 22px;
                color: #fff;
                background-color: #9bc0fe;
            }
        }
    }
</style>
